import axios from "../../../axios";

export default {
    getAllBrandLocations(data) {
        return axios.get('my-data/pois/taxonomies/all-brand-locations', {params: data})
    },
    updateLocation(data) {
        return axios.post('my-data/pois/taxonomies/update-location', data)
    },
    deleteLocation(data) {
        return axios.post('my-data/pois/taxonomies/delete-location', data)
    }
}